import React from 'react'
import { useTranslation } from 'react-i18next'

import './size-selector.styles.scss'

const SizeSelector = ({
  size,
  localSizes,
  productType,
  mix,
  maxQuantity,
  ...otherProps
}) => {
  const { id, weightRange, quantityPerPack, translationKeys } = size
  const { t } = useTranslation('updatedBAB')

  const numberOfSelectedPacks =
    (localSizes && localSizes[id] && localSizes[id].length) ?? 0

  let quantityText = ''

  if (mix && productType === 'diapers') {
    quantityText = t('size.sizeSelector.diapersQuantity', {
      quantity: quantityPerPack
    })
  } else if (!mix && productType === 'diapers') {
    quantityText = t('size.sizeSelector.diapersQuantity', {
      quantity: maxQuantity * quantityPerPack
    })
  } else if (mix && productType === 'pants') {
    quantityText = t('size.sizeSelector.pantsQuantity', {
      quantity: quantityPerPack
    })
  } else if (!mix && productType === 'pants') {
    quantityText = t('size.sizeSelector.pantsQuantity', {
      quantity: maxQuantity * quantityPerPack
    })
  }

  return (
    <li
      className='size-selector-container'
      data-active={numberOfSelectedPacks > 0 ? '' : null}
      data-mix={mix ? '' : null}
      data-id={id}
    >
      <div className='size-selector'>
        <p className='size-identifier'>{t(translationKeys.shortHand)}</p>
        <p className='kid-weight-range'>
          {t('size.sizeSelector.weightRange', {
            firstWeight: weightRange[0],
            secondWeight: weightRange[1]
          })}
        </p>
        <p className='diaper-quantity'>{quantityText}</p>
        {/* <p className="diaper-unit-price">
          {t('size.sizeSelector.pricePerUnit', { pricePerUnit: pricePerUnit })}
        </p> */}
      </div>
      <div className='size-choice'>
        <button className='size-choice-minus'>
          <svg
            width='21'
            height='20'
            viewBox='0 0 21 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <circle cx='10.5' cy='10' r='9.776' fill='#BEEAD2' />
            <rect
              x='5.612'
              y='9.185'
              width='9.776'
              height='1.629'
              fill='white'
            />
          </svg>
        </button>
        <p className='size-choice-quantity'>{numberOfSelectedPacks}</p>
        <button className='size-choice-plus'>
          <svg
            width='21'
            height='20'
            viewBox='0 0 21 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <circle cx='10.5' cy='10' r='9.776' fill='#BEEAD2' />
            <rect
              x='5.612'
              y='9.186'
              width='9.776'
              height='1.629'
              fill='white'
            />
            <rect x='9.69' y='5.112' width='1.62' height='9.776' fill='white' />
          </svg>
        </button>
      </div>
    </li>
  )
}

export default SizeSelector
